export const HTTP = {
    GET: "GET",
    POST: "POST",
    PUT: "PUT",
    DELETE: "DELETE",
};

const ociGateway = import.meta.env.VITE_OCI_GATEWAY_URL;

export const ENDPOINT = {
    GET_ACCOUNT_CODE: (code) =>
        `${ociGateway}/customer/v1/by-account-code/${code}`,
    CREATE_CAMPAIGN: () => `${ociGateway}/campaign/v1/`,
    CREATE_QUOTE: (campaignId) =>
        `${ociGateway}/campaign/v1/${campaignId}/quotes`,
    CREATE_STANDALONE_JOB: () => `${ociGateway}/jobs/v1/create`,
    GET_CAMPAIGN: (campaignId) => `${ociGateway}/campaign/v1/${campaignId}`,
    GET_QUOTE_TOTAL: (q) => `${ociGateway}/calculator/v1/total?${q}`,
    GET_ADMIN_FEE: (q) => `${ociGateway}/rates/v1/admin?${q}`,
    GET_FARMER_QUOTE: (q) => `${ociGateway}/rates/v1/farmer-premium?${q}`,
    GET_FREIGHT_QUOTE: (q) => `${ociGateway}/calculator/v1/freight?${q}`,
    GET_NETWORK_QUOTE: (q) => `${ociGateway}/rates/v1/network-management?${q}`,
    GET_VOLUME_QUOTE: (q) => `${ociGateway}/calculator/v1/volume?${q}`,
    UPDATE_CAMPAIGN: (campaignId) => `${ociGateway}/campaign/v1/${campaignId}`,
    UPDATE_QUOTE: (campaignId, quoteId) =>
        `${ociGateway}/campaign/v1/${campaignId}/quotes/${quoteId}`,
    DELETE_QUOTE: (campaignId, quoteId) =>
        `${ociGateway}/campaign/v1/${campaignId}/quotes/${quoteId}`,
};

export const HTTP_CODES = {
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    SERVER_ERROR: 500,
};
